module.exports = __webpack_public_path__ + "img/logo-dokter.983f9d14.svg";